(function () {
  var STORAGE_KEY = 'qo-show-early-access-popup';
  var DELAY_MS = 3000;

  function init() {
    if (window.Shopify && window.Shopify.designMode) return;

    var popup = document.getElementById('CollectionEarlyAccessPopup');
    if (!popup) return;

    var closeButtons = popup.querySelectorAll('[data-collection-ea-close]');
    var overlay = popup.querySelector('.collection-ea-popup__overlay');
    var emailInput = popup.querySelector('.collection-ea-popup__email');
    var forceOpen = popup.dataset.forceOpen === 'true';
    var shouldOpenFromHome = sessionStorage.getItem(STORAGE_KEY) === '1';

    if (!forceOpen && !shouldOpenFromHome) return;

    if (shouldOpenFromHome) {
      sessionStorage.removeItem(STORAGE_KEY);
    }

    function openPopup() {
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
      });
      document.body.classList.add('overflow-hidden');
      if (emailInput) emailInput.focus();
    }

    function closePopup() {
      popup.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      popup.addEventListener(
        'transitionend',
        function onEnd(evt) {
          if (evt.target !== popup || evt.propertyName !== 'background') return;
          popup.removeEventListener('transitionend', onEnd);
          popup.hidden = true;
        },
        { once: true }
      );
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closePopup);
    });

    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }

    document.addEventListener('keydown', function onKeydown(evt) {
      if (evt.code !== 'Escape' || popup.hidden || !popup.classList.contains('is-open')) return;
      closePopup();
    });

    if (forceOpen) {
      openPopup();
      return;
    }

    setTimeout(openPopup, DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
